var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSubjectPlaceHolder = function SvgSubjectPlaceHolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.499,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.45 33.005h31.5c.177 0 .351-.02.518-.056.168.036.341.056.52.056h18a2.423 2.423 0 0 0 0-4.847H65.91a2.423 2.423 0 1 1 0-4.846h6.577a2.423 2.423 0 1 0 0-4.846h-7.616a2.423 2.423 0 0 0 0-4.846H42.718a2.423 2.423 0 1 0 0-4.846h-19.73a2.423 2.423 0 1 0 0 4.846H9.142a2.423 2.423 0 0 0 0 4.846h8.653a2.423 2.423 0 0 1 0 4.846H3.95a2.423 2.423 0 0 0 0 4.846h13.5a2.423 2.423 0 1 0 0 4.846Zm56.422 0a2.423 2.423 0 1 0 0-4.847 2.423 2.423 0 0 0 0 4.846Z",
    fill: "#EAE6E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m25.507 34.778-1.409.198a1.385 1.385 0 0 1-1.564-1.179L18.68 6.375A1.385 1.385 0 0 1 19.86 4.81l27.08-3.806a1.385 1.385 0 0 1 1.564 1.178l.33 2.357",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m26.382 33.251-1.28.182a1.253 1.253 0 0 1-1.418-1.068l-3.46-24.897a1.262 1.262 0 0 1 1.073-1.422l24.59-3.495a1.252 1.252 0 0 1 1.417 1.068l.298 2.14 3.186 23.053a1.398 1.398 0 0 1-1.18 1.58l-.024.004-23.202 2.855Z",
    fill: "#EAE6E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m25.507 34.778-1.409.198a1.385 1.385 0 0 1-1.564-1.179L18.68 6.375A1.385 1.385 0 0 1 19.86 4.81l27.08-3.806a1.385 1.385 0 0 1 1.564 1.178l.33 2.357",
    stroke: "#E1DDDB",
    strokeWidth: 0.865,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m49.122 6.136.173 1.08",
    stroke: "#D7D3D1",
    strokeWidth: 0.865,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.195 7.558a.952.952 0 0 1 1.046-.847l27.197 2.858a.952.952 0 0 1 .847 1.047l-2.895 27.54a.952.952 0 0 1-1.046.847l-27.196-2.858a.952.952 0 0 1-.847-1.046l2.894-27.54Z",
    fill: "#fff",
    stroke: "#E1DDDB",
    strokeWidth: 0.865
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.574 10.593c.06-.57.57-.985 1.141-.925l21.688 2.28c.57.06.984.57.925 1.141L54.41 31.335c-.06.57-.571.984-1.141.924L31.58 29.98a1.039 1.039 0 0 1-.924-1.14l1.918-18.246Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m33.629 24.654 3.391-2.287a1.385 1.385 0 0 1 1.789.206l2.483 2.673c.124.133.33.148.472.033l5.31-4.302a1.385 1.385 0 0 1 2.034.324l3.455 5.344.496.828-.238 2.812a.346.346 0 0 1-.383.315L32.72 28.409a.346.346 0 0 1-.306-.376l.261-2.838.954-.54Z",
    fill: "#EAE6E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.004 10.638a.606.606 0 0 1 .666-.54l21.688 2.28a.606.606 0 0 1 .54.666L53.978 31.29a.606.606 0 0 1-.665.539l-21.689-2.28a.606.606 0 0 1-.539-.665l1.918-18.246Z",
    stroke: "#E1DDDB",
    strokeWidth: 0.865
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.883,
    cy: 16.372,
    r: 2.077,
    transform: "rotate(6 37.883 16.372)",
    fill: "#EAE6E5",
    stroke: "#E1DDDB",
    strokeWidth: 0.865
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.932 25.19c1.363-.94 4.088-2.823 4.088-2.823a1.385 1.385 0 0 1 1.789.206l2.483 2.673c.124.134.33.148.472.033l5.31-4.302a1.385 1.385 0 0 1 2.034.324l3.83 6.077",
    stroke: "#E1DDDB",
    strokeWidth: 0.865,
    strokeLinecap: "round"
  })));
};
export { SvgSubjectPlaceHolder as ReactComponent };
export default __webpack_public_path__ + "79c191b094481bc4ee833af396aec76e.svg";